
import React from 'react';
import { City } from '../../data/types/city-types';
import { useLanguage } from '../../contexts/language';
import CityCard from './CityCard';

interface CitiesListProps {
  cities: City[];
  onCitySelect: (cityId: string) => void;
  getCityColor: (presence: string) => string;
  getCityFundingPercentage: (city: City) => number;
}

const CitiesList: React.FC<CitiesListProps> = ({ 
  cities, 
  onCitySelect,
  getCityColor,
  getCityFundingPercentage
}) => {
  const { t } = useLanguage();
  
  if (!cities || cities.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-8 mb-6">
      <h3 className="text-xl font-bold text-purple-600 mb-4">{t('citiesInRegion')}</h3>
      <div className="space-y-3">
        {cities.map(city => (
          <CityCard 
            key={city.city_id || city.id}
            city={city}
            onSelect={onCitySelect}
            getCityColor={getCityColor}
            getFundingPercentage={getCityFundingPercentage}
          />
        ))}
      </div>
    </div>
  );
};

export default CitiesList;
